const API_BASE_URL = process.env.REACT_APP_API_URL ?? 'https://futureworkacademy.net/future-work-api';

export const API_URLS = {
  unsubscribe: `${API_BASE_URL}/subscriptions/unsubscribe`,
} as const;
